var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 65,
    viewBox: "0 0 52 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0C11.6644 0 0.000264692 11.6642 0.000264692 25.9837C-0.0939844 46.93 25.012 64.298 26 65C26 65 52.094 46.93 51.9997 26C51.9997 11.6643 40.3356 0 26 0ZM18.8468 42.2078H13.0001V36.361L29.1752 20.2085L35.0219 26.0553L18.8468 42.2078ZM37.7746 23.3025L31.9279 17.4557L36.3869 13L42.2336 18.8467L37.7746 23.3025Z",
    fill: "#5DF99C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetEdit);
export default __webpack_public_path__ + "static/media/target-edit.644738dfe3a2dd827ff1aa32f077af76.svg";
export { ForwardRef as ReactComponent };